import { ResponsiveContainer, ComposedChart, Bar, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend } from "recharts";
import { ChartTooltip } from "./ChartTooltip";
import { fmtCompact } from "../lib/format";

const wkLabel = (w) => new Date(`${w}T00:00:00Z`).toLocaleDateString(undefined, { day: "2-digit", month: "short", timeZone: "UTC" });

export const WeeklyChart = ({ weeks }) => {
  const data = weeks.map((w) => ({ label: wkLabel(w.week), picks: w.picks, hours: +(w.worked / 3600).toFixed(1), lost: +(w.lost / 3600).toFixed(1) }));
  return (
    <div className="panel p-5 sm:p-6" data-testid="weekly-chart">
      <h3 className="font-display text-lg font-semibold text-slate-100 mb-4">Weekly picks, hours worked & lost time</h3>
      <div className="h-[300px]">
        <ResponsiveContainer width="100%" height={300} initialDimension={{ width: 800, height: 300 }}>
          <ComposedChart data={data} margin={{ top: 5, right: 10, left: 0, bottom: 0 }}>
            <CartesianGrid stroke="#1F2937" vertical={false} />
            <XAxis dataKey="label" stroke="#64748B" tick={{ fontSize: 10, fontFamily: "JetBrains Mono" }} tickLine={false} axisLine={{ stroke: "#1F2937" }} minTickGap={12} />
            <YAxis yAxisId="p" stroke="#D4333B" tickFormatter={fmtCompact} tick={{ fontSize: 11 }} tickLine={false} axisLine={false} width={44} />
            <YAxis yAxisId="h" orientation="right" stroke="#F59E0B" tick={{ fontSize: 11 }} tickLine={false} axisLine={false} width={36} unit="h" />
            <Tooltip content={<ChartTooltip />} cursor={{ fill: "#1F2937", opacity: 0.4 }} />
            <Legend wrapperStyle={{ fontSize: 12, paddingTop: 10 }} />
            <Bar yAxisId="p" dataKey="picks" name="Picks" fill="#D4333B" radius={[3, 3, 0, 0]} maxBarSize={28} />
            <Line yAxisId="h" type="monotone" dataKey="hours" name="Hours worked" stroke="#F59E0B" strokeWidth={2.25} dot={false} />
            <Line yAxisId="h" type="monotone" dataKey="lost" name="Lost hours" stroke="#8B5CF6" strokeWidth={2} strokeDasharray="4 3" dot={false} />
          </ComposedChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};
